import { render, staticRenderFns } from "./Icp.vue?vue&type=template&id=3d13939a"
import script from "./Icp.vue?vue&type=script&lang=js"
export * from "./Icp.vue?vue&type=script&lang=js"
import style0 from "./Icp.vue?vue&type=style&index=0&id=3d13939a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports